'use client';

import { ProductTariffResponseV1 } from '@/shared/api';

import { TariffCard } from './tariff-card';
export const TariffPlans = ({
	tariffPlans,
	productId,
}: {
	tariffPlans: ProductTariffResponseV1[];
	productId: string;
}) => {
	return (
		<div className="w-full xl:px-4 xl:py-8">
			<div className="grid grid-cols-1 gap-6 md:gap-6 lg:grid-cols-3">
				{tariffPlans.map((tariff) => (
					<TariffCard
						key={tariff.tariffId}
						tariff={tariff}
						productId={productId}
					/>
				))}
			</div>
		</div>
	);
};
